<template>
<div >
  <ConfigProvider :locale="locale">
    <Layout class="license-layout">
      <Header class="license-header">
        <div class="logo" />
        <div class="user-info">
          <Dropdown>
            <a><i class="icon-header"></i> <span>{{loginName}}</span></a>
            <Menu slot="overlay">
              <MenuItem key="0"  @click="showUpdateModal">
                <span class="icon icon-change-pwd"></span>
                <a>修改密码</a>
              </MenuItem>
              <MenuItem key="1" @click="logout">
                <span class="icon icon-logout"></span>
                <!-- <router-link to="/login">退出登录</router-link> -->
                <a >退出登录</a>
              </MenuItem>
            </Menu>
          </Dropdown>
        </div>
      </Header>
      <Layout class="license-container">
        <Sider class="license-sider" width="161" :style="{ height: '100%', position: 'fixed', left: 0}">
          <div class="side_menu_box">
          <Menu
            mode="inline"
            :default-selected-keys="selectKey"
            :style="{ height: '100%', borderRight: 0 }"
            @click="handleMenuClick"
          >
            <MenuItem key="operations" class="operations">
              <i></i>
              <span>运营分析</span>
            </MenuItem>
            <MenuItem key="emails" class="alert_email">
              <i></i>
              <span>告警邮箱</span>
            </MenuItem>
            <MenuItem key="manage" class="manage">
              <i></i>
              <span>License管理</span>
            </MenuItem>
            <MenuItem key="statistics" class="statistics">
              <i></i>
              <span>License统计总览</span>
            </MenuItem>
            <MenuItem key="logs" class="logs">
              <i></i>
              <span>操作日志</span>
            </MenuItem>
          </Menu>
          </div>
        </Sider>
        <Layout class="license-box">
          <Breadcrumb v-if="$route.path !== '/operations'" class="license-breadcrumb">
            <BreadcrumbItem>{{ title }}</BreadcrumbItem>
          </Breadcrumb>
          <Content class="license-content">
            <router-view />
          </Content>
          <Footer class="license-footer"
            >{{copyright}}</Footer
          >
        </Layout>
      </Layout>
    </Layout>
  </ConfigProvider>
    <div class="update_pwd_box" v-if="isShowUpdateModal" ref="update_modal">
          <Modal  centered
             @cancel="cancelAndReset"
             width="400px"
             :getContainer="()=>this.$refs.update_modal"
          :visible="isShowUpdateModal" title="修改密码" @ok="confirmUpdate" class="updatePwd">
            <div class="update_pwd_body">
              <Form layout="inline" class="update_pwd_form" >
               
                <FormItem class="form_item">
                   <span class="label_text">当前密码</span>
                    <Input v-model.trim="currentpwd" :type=inputType placeholder="请输入当前使用密码" />
                </FormItem>
                <FormItem class="form_item">
                   <span class="label_text">新密码&emsp;</span>
                    <Input v-model.trim="newpwd"  :type=inputType placeholder="请输入新密码" />
                </FormItem>
                <FormItem   class="form_item">
                   <span class="label_text">确认密码</span>
                    <Input  v-model.trim="repwd"  :type=inputType placeholder="请再次输入新密码" />
                </FormItem>

              </Form>
              <div class="error_tips" v-show="isExistErr">
                <span class="tips_icon"></span>
                <span class="tips_text">{{tips_text}}</span>
              </div>
              
            </div>
              <div slot="footer" >
                <div class="bottom_check_confirm">
                  <a-checkbox :checked="isChecked" @change="handleChange"><span class="show_pwd">显示密码</span></a-checkbox>
                  <Button type="primary"  @click="confirmUpdate">
                    确定
                </Button>
                </div>
              </div>
        </Modal>
    </div>
</div>
</template>
<script>
import './layout.less'
import './updatePwd.less'
import { Layout,Modal,Input,Button,Checkbox, Menu,Form, Breadcrumb, Dropdown } from 'ant-design-vue'
import { ConfigProvider } from 'ant-design-vue'
const { Header, Content, Sider, Footer } = Layout
const { Item: MenuItem } = Menu
const { Item: BreadcrumbItem } = Breadcrumb
const { Item: FormItem} = Form
import zhCn from 'ant-design-vue/lib/locale-provider/zh_CN'
import { createNamespacedHelpers } from 'vuex'
const { mapMutations,mapActions,mapState } = createNamespacedHelpers('user')
import user_service from '../model/user_service.js';

import { encodePwd } from '@/util/utils.js'
export default {
  data() {
    return {
      selectKey: [],
      locale: zhCn,
      title: '运营分析',
      isShowUpdateModal:false,
      isChecked:false,
      inputType:"password",
      currentpwd:"",
      newpwd:"",
      repwd:"",
      tips_text:"修改密码失败",
      isExistErr:false,
      copyright:"",
      isLogOut:"",
      list:{operations:'运营分析','emails':'告警邮箱', manage:'License管理',statistics:'License统计总览',logs:'操作日志',}
    }
  },
  created() {
    const pathKey = this.$route.path.replace('/', '')
    this.selectKey = [pathKey]
    this.title = this.list[pathKey] || '运营分析'
    this.getCopyright();
    // this.getLogin()
  },
  computed:{
  ...mapState(['loginName'])
  },
  mounted() {
    window.removeEventListener('beforeunload', this.beforeunloadFn())
  },
  methods: {
    ...mapMutations(['isLogin']),
    ...mapActions(['updatePwd','getFooterCopyright','goToLogout','getLogin']),
    async getCopyright(){
      let res = await this.getFooterCopyright();
      this.copyright=res
    },
    handleMenuClick(item) {
      if ('/' + item.key === this.$route.path) {
        return
      }
      this.selectKey = [item.key]
      this.title = this.list[item.key]
      this.$router.push(item.key)
      // this.title = this.$route.meta.title
    },
    // 注销退出
    logout() {
      user_service.logOut().then(result=>{
        if(result.data.msg == 'success'){
            this.isLogin(false)
            this.$router.push('/login')
        }

      })
      // this.isLogin(false)
      // this.$router.push('/login')
    },
    showUpdateModal(){
      // 展示修改密码弹窗
    this.isShowUpdateModal=true
    },
    // 控制密码显示隐藏
    handleChange(e){
      this.isChecked = e.target.checked;
      if(e.target.checked){
        this.inputType="text"
      }else{
        this.inputType="password"
      }
    },
    cancelAndReset(){
      this.isExistErr=false
      this.isShowUpdateModal=false;
      this.currentpwd="";
      this.newpwd="";
      this.repwd=""
    },
    // 确定修改
    confirmUpdate(){
      //
      if(this.currentpwd&&this.newpwd&&this.repwd&&this.repwd){
        if(this.newpwd.trim() === this.repwd.trim()){
          // 调用接口
          let params ={
            newPwd:encodePwd(this.newpwd),
            oldPwd:encodePwd(this.currentpwd)
          }
          this.updatePwd(params).then(result=>{
            if(result==true){
              this.isExistErr=false
              this.$message.success('修改密码成功')
              this.isShowUpdateModal=false
              this.cancelAndReset()
            }
            else{
              //  window.clearTimeout(timer1);
              this.isExistErr=true
              this.tips_text=result.msg
            }
          })
        }
        else{
          this.$message.error('确认密码不一致')
        }
      }
      else{
        this.$message.error('请完整填写内容')
      }
    },
    beforeunloadFn() {
      this.$store.state.user.isLogin = true
    },
  },
  components: {
    Layout,
    Menu,
    Header,
    Content,
    Footer,
    Sider,
    MenuItem,
    Breadcrumb,
    BreadcrumbItem,
    Dropdown,
    ConfigProvider,
    Modal,
    Button,
    Input,
    FormItem,
    "a-checkbox": Checkbox
  },
}
</script>
